import { Builder } from '@builder.io/react';
import { PaymentsAccepted } from './PaymentsAccepted';

Builder.registerComponent(PaymentsAccepted, {
  name: 'PaymentsAccepted',
  friendlyName: 'Payments Accepted',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'description',
      type: 'string',
      required: true,
    },
    {
      name: 'footer',
      type: 'string',
      required: true,
    },
  ],
});
